export const MULTIPLE_CHOICE_ID = 1;
export const TRUE_OR_FALSE_ID = 2;
export const ESSAY_ID = 9;

export const MULTIPLE_CHOICE_NAME = 'Multiple Choice';
export const ESSAY_NAME = 'Essay';

export const QUESTION_TYPES = [
  { Name: 'Multiple Choice', Id: MULTIPLE_CHOICE_ID },
  { Name: 'True or False', Id: TRUE_OR_FALSE_ID },
  { Name: 'Essay', Id: ESSAY_ID },
];

export const QUESTION_TYPE_NAME_TO_ID = QUESTION_TYPES.reduce((map, type) => {
  map[type.Name.toLowerCase()] = type.Id;
  return map;
}, {});

export const questionPromptTemplate = `Please generate a CSV file for quiz questions about { topic } with the following format:
  
Required Headers:
- questionTitle (required): The question text (can include HTML)
- mark (required): Numeric value > 0 and <= 100

Optional Headers:
- explanation: Explanation text for the answer
- autoCheckInstruction: Instructions for auto-checking (required if isAllowedAutoCheck is true)
- multipleChoiceChoicesJson: JSON array of choice objects with "option" and "value" properties (required for Multiple Choice questions)
- multipleChoiceAnswersJson: JSON array of answer objects with "option" and "value" property (required for Multiple Choice questions)
- allowPartialPoints: Boolean (true/false)
- isAllowedAutoCheck: Boolean (true/false)
- questionTypeName: Must be one of: "Multiple Choice", "Essay"

Example for Multiple Choice question (strict format):
questionTitle,explanation,multipleChoiceChoicesJson,multipleChoiceAnswersJson,allowPartialPoints,isAllowedAutoCheck,mark,questionTypeName
"What is 2+2?","Basic arithmetic","[{\\"option\\":\\"A\\",\\"value\\":\\"3\\"},{\\"option\\":\\"B\\",\\"value\\":\\"4\\"}]","[{\\"option\\":\\"B\\",\\"value\\":\\"4\\"}]",false,false,1,"Multiple Choice"

Please generate { X } questions following this format.`;
